import axios from 'axios';
import Vue from 'vue';
import 'element-ui/lib/theme-chalk/index.css'
import { format } from 'path';

let baseUrl = process.env.BASE_URL
axios.defaults.baseURL = baseUrl
axios.defaults.timeout = 5000
    // 拦截request,设置全局请求为ajax请求
axios.interceptors.request.use((config) => {
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    return config;
})

const httpServe = {}
httpServe.serve_host = baseUrl;
httpServe.getPbsApi = function(url) {
    return '/pbs' + url;
};
httpServe.getFileApi = function(url) {
    return '/file' + url;
};
httpServe.getUmsUrl = function(url) {
    return '/ums' + url;
};
httpServe.getOmsUrl = function(url) {
    return '/oms' + url;
};
httpServe.getVpsUrl = function(url) {
    return '/vps' + url;
};
httpServe.getUumpUrl = function(url) {
    return '/uump' + url;
};
httpServe.getTompUrl = function(url) {
    return '/tomp' + url;
};
httpServe.getTeamUrl = function(url) {
    return '/team' + url;
}
httpServe.setToken = function(token) {
    let me = this;
    if (token != null && token != undefined) {
        if (token['access_token']) {
            window.sessionStorage.setItem("access_token", token.access_token);
        }
        if (token['access_overtime']) {
            window.sessionStorage.setItem("access_overtime", token.access_overtime);
        }
        if (token['refresh_token']) {
            window.sessionStorage.setItem("refresh_token", token.refresh_token);
        }
        if (token['refresh_overtime']) {
            window.sessionStorage.setItem("refresh_overtime", token.refresh_overtime);
        }
    }
};
httpServe.getToken = async function() {
    let me = this;
    let access_token = await window.sessionStorage.getItem("access_token");
    if (access_token) {
        let overtime = parseInt(await window.sessionStorage.getItem('access_overtime')) - 600000;
        let refresh_token = await window.sessionStorage.getItem('refresh_token');
        if (overtime < new Date().getTime()) { //token过期
            if (refresh_token) {
                let url = me.getUumpUrl('/pub/user/refresh_token');
                let res = await me.changeRefreshToken(url, refresh_token);
                await me.setToken(res['data']['content']);
                let token = window.sessionStorage.getItem("access_token")
                return token;
            } else {
                return '';
            }
        } else {
            return access_token;
        }
    } else {
        return '';
    }
}
httpServe.changeRefreshToken = async function(url, token) {
    let headers = {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "access_token": await window.sessionStorage.getItem("access_token")
    }
    let fromdata = {};
    fromdata.refreshToken = token;
    let rs = null;
    await axios.post(url, fromdata, { headers: headers }).then(res => {
        rs = res;
    }).catch(e => {
        rs = e.response;
    });
    rs = this.checkResponse(rs);
    if (rs && rs['data'] && !rs['data']['success']) {
        Vue.prototype.$message({ message: rs['data']['errmsg'], type: 'error' });
    }
    return rs;
}
httpServe.ajaxGet = async function(url, needToken = true) {
    let headers = {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
    };
    if (needToken) {
        headers.access_token = await this.getToken();
    }
    let rs = null;
    await axios.get(url, {
        headers: headers,
    }).then(res => {
        rs = res;
    }).catch(e => {
        rs = e.response;
    });
    rs = await this.checkResponse(rs);
    if (rs && rs['data'] && !rs['data']['success']) {
        Vue.prototype.$message({ message: rs['data']['errmsg'], type: 'error' });
    }
    return rs;
};
httpServe.ajaxPost = async function(url, param = {}, needToken = true, showError = true) {
    let headers = {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
    };
    if (needToken) {
        headers.access_token = await this.getToken();
    }
    let rs = null;
    await axios.post(url, param, { headers: headers }).then(res => {
        rs = res;
    }).catch(e => {
        rs = e.response;
    });
    rs = await this.checkResponse(rs);
    if (rs && rs['data'] && !rs['data']['success'] && showError) {
        if (["/uump/api/registration/loadFeiShuiHtml", "/uump/api/registration/travelToPay"].includes(url)) {
            return rs;
        }
        Vue.prototype.$alert(`<strong style="color: red;font-size: 16px;word-break: break-all;">${rs['data']['errmsg']}</strong>`, '提示', {
            dangerouslyUseHTMLString: true,
            type: 'error',
            confirmButtonText: '确定'
        });
        // Vue.prototype.$message({ message: rs['data']['errmsg'], type: 'error' });
    }
    return rs;
};
httpServe.ajaxP = async function(url, param = {}, needToken = true, showError = true) {
    let headers = {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
    };
    if (needToken) {
        headers.access_token = await this.getToken();
    }
    let rs = null;
    await axios.post(url, param, { headers: headers }).then(res => {
        rs = res;
    }).catch(e => {
        rs = e.response;
    });
    rs = await this.checkResponse(rs);

    return rs;
};
httpServe.Post = async function(url, param, authorization) {
    let headers = {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        'authorization': authorization
    };
    let rs = null;
    await axios.post(url, param, { headers: headers }).then(res => {
        rs = res;
    }).catch(e => {
        rs = e.response;
    });

    return rs;
};
httpServe.ajaxPostFile = async function(url, param = {}, needToken = true) {
    let headers = {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
    }
    if (needToken) {
        headers.access_token = await this.getToken()
    }
    let rs = null
    await axios.post(url, param, { headers: headers, responseType: 'blob' }).then(res => {
        rs = res
    }).catch(e => {
        rs = e.response
    })
    rs = await this.checkResponse(rs)
    if (rs.headers['content-type'] === 'application/json;charset=UTF-8') {
        if (rs && rs['data'] && !rs['data']['success']) {
            Vue.prototype.$message({ message: rs['data']['errmsg'], type: 'error' })
        }
    }
    return rs
}
httpServe.upload = async function(url, file, needToken = true) {
    let headers = {
        'Content-Type': 'multipart/form-data',
        "Access-Control-Allow-Origin": "*",
    };
    if (needToken) {
        headers.access_token = await this.getToken();
    }
    let postData = new FormData();
    postData.append('file', file);
    let rs = null;
    await axios.post(url, postData, { headers: headers }).then(res => {
        rs = res;
    }).catch(e => {
        rs = e.response;
    });
    rs = await this.checkResponse(rs);
    if (rs && rs['data'] && !rs['data']['success']) {
        Vue.prototype.$message({ message: rs['data']['errmsg'], type: 'error' });
    }
    return rs;
};
httpServe.checkResponse = async function(err) {
    switch (err.status) {
        case 400:
            err['data'] = {};
            err['data']['success'] = false;
            err['data']['errmsg'] = '请求错误';
            break;

        case 401:
            err['data'] = {};
            err['data']['success'] = false;
            err['data']['errmsg'] = '未授权，请登录';
            break;

        case 403:
            err['data'] = {};
            err['data']['success'] = false;
            err['data']['errmsg'] = '拒绝访问';
            break;

        case 404:
            err['data'] = {};
            err['data']['success'] = false;
            err['data']['errmsg'] = `请求地址出错: ${err.config.url}`;
            break;

        case 408:
            err['data'] = {};
            err['data']['success'] = false;
            err['data']['errmsg'] = '请求超时';
            break;

        case 500:
            err['data'] = {};
            err['data']['success'] = false;
            err['data']['errmsg'] = '服务器内部错误';
            break;

        case 501:
            err['data'] = {};
            err['data']['success'] = false;
            err['data']['errmsg'] = '服务未实现';
            break;

        case 502:
            err['data'] = {};
            err['data']['success'] = false;
            err['data']['errmsg'] = '网关错误';
            break;

        case 503:
            err['data'] = {};
            err['data']['success'] = false;
            err['data']['errmsg'] = '服务不可用';
            break;

        case 504:
            err['data'] = {};
            err['data']['success'] = false;
            err['data']['errmsg'] = '网关超时';
            break;

        case 505:
            err['data'] = {};
            err['data']['success'] = false;
            err['data']['errmsg'] = 'HTTP版本不受支持';
            break;

        default:
    }
    return err;
};
export default httpServe;


// WEBPACK FOOTER //
// ./src/utils/httpServe.js